import script from "./AutoComplete.vue?vue&type=script&setup=true&lang=js"
export * from "./AutoComplete.vue?vue&type=script&setup=true&lang=js"

import "./AutoComplete.vue?vue&type=style&index=0&id=7325126e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7325126e"]])

export default __exports__